<template>
  <ModalDialog v-model="isShow" :width="95">
    <div class="p-5" slot="dialog-content">
      <SignDocument
        :documents="documents"
        :isSentRequest="isSentRequest"
        :passedDocument="document"
        :passedUser="user"
        :hasCancelBtn="true"
        @documentSigned="handleSignDocument($event)"
        @documentSaved="handleSaveDocument($event)"
        @cancel="hideModal()"
      >
      </SignDocument>
    </div>
  </ModalDialog>
</template>
<script>
import ModalDialog from "../global-dialogs/ModalDialog.vue";
import SignDocument from "./SignDocument.vue";

export default {
  name: "SigningDocumentDialog",
  props: {
    // Status of dialog: Open, close
    value: Boolean,
    documents: {
      type: Array,
      default: () => [],
    },
    template: {
      type: Object,
      default: () => {},
    },
    user: {
      type: Object,
      default: () => {},
    },
    fieldsLabels: Array,
    fields: Array,
    signatures: Array,
    isSentRequest: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShow: false,
      document: {},
    };
  },
  components: {
    SignDocument,
    ModalDialog,
  },
  methods: {
    hideModal() {
      this.isShow = false;
      this.$emit("input", false);
    },
    showModal() {
      this.document = {
        ...this.template,
        fields: [],
      };
      if (this.fieldsLabels) {
        this.document.fields_labels = this.fieldsLabels;
      }
      if (this.fields && this.fields.length) {
        this.document.fields = this.fields;
      }
      if (this.signatures && this.signatures.length) {
        this.document.signers = this.signatures;
      }
      this.isShow = true;
    },
    handleSignDocument(data) {
      this.$emit("signed", data);
      this.hideModal();
    },
    handleSaveDocument(data) {
      this.$emit("saved", data);
      this.hideModal();
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value === true) {
          this.showModal();
        } else {
          this.hideModal();
        }
      },
    },
    isShow: {
      immediate: true,
      handler() {
        this.$emit("input", this.isShow);
      },
    },
  },
};
</script>

<style scoped>
.document-header {
  text-align: center;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.3;
}

.button-containers {
  display: flex;
  flex-direction: row-reverse;
}

.cancel-btn-container {
  flex-grow: 1;
}

@media (max-width: 600px) {
  .button-containers {
    display: block;
    text-align: center;
  }

  .cancel-btn-container {
    margin-top: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/documents/SigningDocumentDialog.vue